import { render, staticRenderFns } from "./my-form-input.vue?vue&type=template&id=20f474c2&scoped=true&"
import script from "./my-form-input.vue?vue&type=script&lang=js&"
export * from "./my-form-input.vue?vue&type=script&lang=js&"
import style0 from "./my-form-input.vue?vue&type=style&index=0&id=20f474c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f474c2",
  null
  
)

export default component.exports